import React, {useRef, useState} from "react";
import {classNames} from '../../../common/util/util-helpers';
import LocalStorage from "../../../common/util/localStorage";
import {useHistory} from "react-router";
import MainMenuData from "../../../../src/assets/menus/menu-main.json"
import {
    ArrowLeftOnRectangleIcon,
    ArrowPathIcon,
    ChartPieIcon,
    CircleStackIcon,
    UserCircleIcon
} from "@heroicons/react/20/solid";
import ChevronRightIcon from "@heroicons/react/24/outline/ChevronRightIcon";
import {useDispatch, useSelector} from "react-redux";
import PageHeader from "../../../common/components/layout/layout-components/page/page-header";
import Page from "../../../common/components/layout/layout-components/page";
import ModalConfirm from "../../../common/components/modal/modal-confirm";
import Layout from "../../../common/components/layout";
import {clearCookies} from "../../../common/util/util-auth";
import Button from "../../../common/components/button";
import ModalDefault from "../../../common/components/modal/modal-default";
import UserSettingsProfiles from "./ui-tools-components/user-settings-profiles";
import ButtonSplit from "../../../common/components/button/button-integration/button-split";
import FunnelIcon from "@heroicons/react/24/outline/FunnelIcon";
import TableCellsIcon from "@heroicons/react/20/solid/TableCellsIcon";

export default function UiToolsView(props) {
    const history = useHistory();
    const excludedPages = ["/dispatch-expiry-items", "/dispatch-templates", "/dispatch-settings", "/tasks-settings", "/fleet-settings", "/safety-settings"];

    const dispatch = useDispatch()
    const ui = useSelector((state) => state.ui)
    const user = useSelector((state) => state.user)

    const confirmAction = useRef(() => null);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [confirmModalTitle, setConfirmModalTitle] = useState("");
    const [confirmModalContent, setConfirmModalContent] = useState("");
    const [sections, setSections] = useState(() => getSections() ?? {});
    const [isProfilesDialogOpen, setIsProfilesDialogOpen] = useState(false);

    function handleClearLocalstorageClick() {
        setConfirmModalTitle("Clear localstorage data");
        setConfirmModalContent("Clearing localstorage data will reset all of your table filter and column settings");
        confirmAction.current = clearLocalstorage;
        setIsConfirmModalOpen(true);
    }

    function handleClearCookiesClick() {
        clearCookies();
        LocalStorage.set("redirect_path", '/tools');
        history.push('/login')
    }

    function clearLocalstorage() {
        const initialState = LocalStorage.get('initial_storage_state');

        // Preserve keys
        const preserve = LocalStorage.get('seen_major_update_notification');

        localStorage.clear();

        // Restore preserved keys
        if (preserve) {
            LocalStorage.set('seen_major_update_notification', preserve);
        }

        if (initialState) {
            LocalStorage.set('initial_storage_state', initialState);
        }

        LocalStorage.set("redirect_path", '/tools');
        history.push('/logging-in')
    }

    function handleClearPageTableDataClick(sectionKey, pageName, storageKey) {
        localStorage.removeItem(storageKey + "_state");
        localStorage.removeItem(storageKey + "_query");
        localStorage.removeItem(storageKey + "_table_filters");
        localStorage.removeItem(storageKey + "_filters");
        localStorage.removeItem(storageKey.replace("-", "_") + "_filters");
        localStorage.removeItem(storageKey.replace("-", "_") + "_table_filters");
        localStorage.removeItem(storageKey + "_table_options");
        localStorage.removeItem(storageKey + "_column_filters");

        let sectionsClone = Object.assign({}, sections);
        sectionsClone[sectionKey].list.map(page => {
            if (page.name === pageName) {
                page.hasTableData = false;
            }
            return page;
        });
        setSections(sectionsClone);
    }

    function handleClearSetting(pageName, setting) {
        if (setting === 'query') {
            localStorage.removeItem(pageName + "_query");
        }

        if (setting === 'table_options') {
            localStorage.removeItem(pageName + "_table_options");
        }


        setSections(getSections());
    }

    function handleClearAllSetting(pageName) {
        localStorage.removeItem(pageName + "_query");
        localStorage.removeItem(pageName + "_table_options");

        setSections(getSections());
    }

    function handleClearTabTableDataClick(sectionKey, pageName, tabKey) {
        localStorage.removeItem(tabKey + "_state");
        localStorage.removeItem(tabKey + "_query");
        localStorage.removeItem(tabKey + "_table_filters");
        localStorage.removeItem(tabKey.replace("-", "_") + "_table_filters");
        localStorage.removeItem(tabKey + "_table_options");

        let sectionsClone = Object.assign({}, sections);
        sectionsClone[sectionKey].list.map(page => {
            if (page.tabs) {
                page = page.tabs.map(tab => {
                    if (tab.key === tabKey) {
                        tab.hasTableData = false;
                    }
                    return tab;
                })
            }
            return page;
        });

        setSections(sectionsClone);
    }

    function handleReLoginClick() {
        LocalStorage.set("redirect_path", '/tools');
        LocalStorage.remove('user');
        history.push('/logging-in');
    }

    function handleExpandSectionClick(key) {
        const sectionsClone = Object.assign({}, sections);
        sectionsClone[key].isExpanded = !sectionsClone[key].isExpanded;
        setSections(sectionsClone);
    }

    function handleExpandPageClick(sectionKey, pageName) {
        const sectionsClone = Object.assign({}, sections);
        const page = sectionsClone[sectionKey].list.find(p => p.name === pageName);
        if (page) {
            page.isExpanded = !page.isExpanded;
        }
        setSections(sectionsClone);
    }

    function getSections() {
        return MainMenuData.reduce((memo, menu) => {
            if (menu.children) {
                menu.children.filter(it => it.isVisible && !excludedPages.includes(it.link)).forEach(page => {
                    if (!memo[menu.name]) {
                        memo[menu.name] = {};
                        memo[menu.name].list = [];
                    }
                    const pageKey = page.link.slice(1);
                    memo[menu.name].hasChildren = true;

                    page.hasTableData = !!localStorage.getItem(pageKey + "_state") || !!localStorage.getItem(pageKey + "_filters") || !!localStorage.getItem(pageKey + "_table_options") || !!localStorage.getItem(pageKey + "_query") || !!localStorage.getItem(pageKey + "_column_filters");

                    if (menu.name === 'My company') {
                        page.hasQuery = !!localStorage.getItem(pageKey + "_query");
                        page.hasTableOptions = !!localStorage.getItem(pageKey + "_table_options");
                    }

                    if (page.hasTableData) {
                        memo[menu.name].hasTableData = true;
                        memo[menu.name].isExpanded = true;
                    }

                    if (page.tabs) {
                        page.tabs.map(tab => {
                            tab.hasTableData = !!localStorage.getItem(tab.key + "_state") || !!localStorage.getItem(tab.key + "_query") || !!localStorage.getItem(tab.key + "_table_options");

                            if (tab.hasTableData) {
                                memo[menu.name].hasTableData = true;
                                memo[menu.name].isExpanded = true;

                                // memo[menu.name].hasQuery = !!localStorage.getItem(tab.key + "_query");
                                // memo[menu.name].hasTableOptions = !!localStorage.getItem(tab.key + "_table_options");
                            }

                            return tab;
                        })

                        page.isExpanded = page.tabs.some(tab => tab.hasTableData);
                    }

                    memo[menu.name].list.push(page);
                })
            } else if (menu.name === 'Contacts') {
                menu.hasTableData = localStorage.getItem("contacts_query") || localStorage.getItem("contacts_table_options");

                if (!memo[menu.name]) {
                    memo[menu.name] = {};
                    memo[menu.name].list = [];
                }

                if (menu.hasTableData) {
                    memo[menu.name].isExpanded = true;
                    menu.hasQuery = !!localStorage.getItem("contacts_query");
                    menu.hasTableOptions = !!localStorage.getItem("contacts_table_options")
                }

                memo[menu.name].list.push(menu);
            }
            return memo;
        }, {});
    }

    return <Layout {...props} ui={ui} dispatch={dispatch} history={history} user={user}>
        <Page>
            <PageHeader title={'UI tools'}/>
            <div className="space-y-2 pb-8">
                <div className="flex items-center gap-2">
                    <div className="flex items-center gap-2 shrink-0">
                        <button
                            onClick={() => window.location.reload(true)}
                            className="btn btn-outline"
                        >
                            <ArrowPathIcon className="w-4 h-4 mr-1 -ml-1"/> Hard refresh
                        </button>

                        <button
                            onClick={handleClearCookiesClick}
                            className="btn btn-outline"
                        >
                            <ChartPieIcon className="w-4 h-4 mr-1 -ml-1"/>Clear cookies
                        </button>

                        <button
                            onClick={handleClearLocalstorageClick}
                            className="btn btn-outline"
                        >
                            <CircleStackIcon className="w-4 h-4 mr-1 -ml-1"/> Clear localstorage
                        </button>

                        <button
                            onClick={handleReLoginClick}
                            className="btn btn-outline"
                        >
                            <ArrowLeftOnRectangleIcon className="w-4 h-4 mr-1 -ml-1"/> Re-login
                        </button>
                    </div>

                    <div className="flex w-full items-center justify-end">
                        <Button
                            appearance="primary"
                            onClick={() => setIsProfilesDialogOpen(true)}
                        >
                            <UserCircleIcon className="w-4 h-4 mr-1 -ml-1"/>

                            Profiles
                        </Button>
                    </div>
                </div>


                <div className="rounded-card border border-tm-gray-200 shadow-xs mb-24">
                    {Object.keys(sections).map(sectionKey => {
                        return <div key={sectionKey}>
                            <div className="border-t border-tm-gray-200">
                                <div
                                    className="bg-tm-gray-50 h-10 flex items-center pl-4 pr-3 text-left text-sm font-bold text-tm-gray-900 sm:pl-3"
                                >
                                    <button
                                        onClick={() => handleExpandSectionClick(sectionKey)}
                                        className="btn btn-icon w-8 h-8 -ml-2 md mr-2"
                                    >
                                        <ChevronRightIcon
                                            className={
                                                classNames("w-5 h-5", sections[sectionKey]?.isExpanded ? "rotate-90" : undefined)
                                            }
                                        />
                                    </button>

                                    <span className="uppercase">{sectionKey}</span>
                                    {!sections[sectionKey]?.isExpanded && !sections[sectionKey]?.hasTableData ?
                                        <span className="text-tm-gray-400 ml-2">(No data)</span> : undefined}
                                </div>
                            </div>

                            {sections[sectionKey]?.isExpanded && sections[sectionKey].list.map(page => {
                                const hasQuery = page.hasQuery;
                                const hasTableOptions = page.hasTableOptions;
                                const hasOptions = hasQuery || hasTableOptions;

                                return (
                                    <>
                                        <div
                                            key={page.name}
                                            className="pl-16 pr-8 flex items-center justify-between border-t h-10 border-tm-gray-300 font-bold bg-inverse hover:bg-tm-gray-100"
                                        >
                                            <div className="flex items-center">
                                                {!!page.tabs?.length && (
                                                    <button
                                                        onClick={() => handleExpandPageClick(sectionKey, page.name)}
                                                        className="btn btn-icon w-8 h-8 -ml-2 mr-2"
                                                    >
                                                        <ChevronRightIcon
                                                            className={classNames("w-5 h-5", page.isExpanded ? "rotate-90" : undefined)}
                                                        />
                                                    </button>
                                                )}

                                                {page.name}

                                                {!!page.tabs?.length && !page.isExpanded && !page.tabs.some(tab => tab.hasTableData) && (
                                                    <span className="text-tm-gray-400 ml-2 font-normal">(No data)</span>
                                                )}
                                            </div>

                                            {!hasOptions && page.hasTableData && (
                                                <button
                                                    className="btn btn-outline py-0.5 h-8 w-44"
                                                    onClick={() => handleClearPageTableDataClick(sectionKey, page.name, page.link.slice(1))}
                                                >
                                                    Clear table settings
                                                </button>
                                            )}

                                            {!hasOptions && !page.hasTableData && !page?.tabs?.length &&  (
                                                <div className="w-44 text-center">No table data</div>
                                            )}

                                            {hasOptions && (
                                                <ButtonSplit
                                                    label="Clear all settings"
                                                    onClick={() => handleClearAllSetting(page.link.slice(1))}
                                                    menuContent={
                                                        <div
                                                            className="flex flex-col text-tm-gray-700 divide-y divide-tm-gray-200">
                                                            <button
                                                                disabled={!hasQuery}
                                                                onClick={() => handleClearSetting(page.link.slice(1), 'query')}
                                                                className="w-full py-2 px-4 text-left hover:bg-tm-gray-200 hover:text-tm-gray-900 cursor-pointer disabled:cursor-default flex items-center gap-2"
                                                            >
                                                                <FunnelIcon className="size-5"/> Clear table
                                                                filters <div
                                                                className={classNames("size-2 ml-auto rounded-full", hasQuery ? "bg-green-600" : "bg-tm-gray-300")}></div>
                                                            </button>

                                                            <button
                                                                disabled={!hasTableOptions}
                                                                onClick={() => handleClearSetting(page.link.slice(1), 'table_options')}
                                                                className="w-full py-2 px-4 text-left hover:bg-tm-gray-200 hover:text-tm-gray-900 cursor-pointer disabled:cursor-default flex items-center gap-2"
                                                            >
                                                                <TableCellsIcon className="size-5"/> Clear table
                                                                options <div
                                                                className={classNames("size-2 ml-auto rounded-full", hasTableOptions ? "bg-green-600" : "bg-tm-gray-300")}></div>
                                                            </button>
                                                        </div>
                                                    }
                                                />
                                            )}
                                        </div>

                                        {!!page.tabs && page.isExpanded && page.tabs.map(tab => {
                                            return <div
                                                key={sectionKey + tab.key}
                                                className="pl-16 pr-8 h-10 flex items-center justify-between border-t border-tm-gray-300 bg-inverse hover:bg-tm-gray-100"
                                            >
                                                <span><span className="mr-6 text-tm-gray-400">•</span>{tab.name}</span>

                                                {tab.hasTableData && (
                                                    <button
                                                        className="btn btn-outline py-0.5 h-8 w-44"
                                                        onClick={() => handleClearTabTableDataClick(sectionKey, page.name, tab.key)}
                                                    >
                                                        Clear table settings
                                                    </button>
                                                )}

                                                {!tab.hasTableData && (
                                                    <div className="w-44 text-center">No table data</div>
                                                )}
                                            </div>
                                        })}
                                    </>
                                )
                            })}
                        </div>
                    })}
                </div>

                <ModalDefault
                    show={isProfilesDialogOpen}
                    widthClass="max-w-4xl"
                    title={props.translate('modal_heading.profile_settings')}
                    onClose={() => setIsProfilesDialogOpen(false)}
                    closeButtonLabel={props.translate('btn.close')}
                    translate={props.translate}
                >
                    <UserSettingsProfiles
                        onClose={() => setIsProfilesDialogOpen(false)}
                        onReLogin={handleReLoginClick}
                        translate={props.translate}
                    />
                </ModalDefault>

                <ModalConfirm
                    title={confirmModalTitle}
                    show={isConfirmModalOpen}
                    onClose={() => setIsConfirmModalOpen(false)}
                    buttonLabel={'Confirm'}
                    closeButtonLabel={'Cancel'}
                    translate={props.translate}
                    onConfirm={() => {
                        setIsConfirmModalOpen(false);
                        if (confirmAction.current) {
                            confirmAction.current();
                        }
                    }}
                >
                    {confirmModalContent}
                </ModalConfirm>
            </div>
        </Page>

    </Layout>
}
